import axiosHttp from "./interceptor.service";

const postRequest = (data) => {
  return axiosHttp.post("/lmt/createRequest", data);
};

const getRequest = ({
  search,
  sort,
  page,
  limit,
  status,
  employee,
  client,
  projectId
} = {}) => {
  return axiosHttp.get("/lmt/getRequest", {
    params: { search, sort, page, limit, status, employee, client ,projectId},
  });
};

const updateRequest = (id, data) => {
  return axiosHttp.put(`/lmt/updateRequest/${id}`, data);
};

const deleteRequest = (id, data) => {
  return axiosHttp.delete(`/lmt/deleteRequest/${id}`, data);
};

export { postRequest, getRequest, updateRequest, deleteRequest };
